module.exports = __webpack_public_path__ + "static/media/tews-logo.855f2744.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tews-logo.png
// module id = 1537
// module chunks = 0